import { deleteCookie, getCookie } from "cookies-next";
import { getRequestMeta } from "next/dist/server/request-meta";

import { getPageTypes } from "@config/cms";
import { getSsrCmsPageProps } from "@utils/getSsrCmsPageProps";
import {
  getPreferredHomeRedirect,
  PREFERRED_LOCALE_COOKIE,
} from "@utils/preferredLanguage";
import { renderPage } from "@utils/renderPage";

export default function HomePage(props) {
  return renderPage(props);
}

export const getServerSideProps = async (props) => {
  const { req, res, locales, locale, defaultLocale } = props;
  const lang = getCookie("lang", { req, res });
  if (lang && !locales.includes(lang)) deleteCookie("lang", { req, res });

  // Next 13 strips explicit /et (the default locale) from req.url before GSSP.
  // Its original request URL preserves the distinction from a neutral / entry.
  const originalUrl = getRequestMeta(req, "__NEXT_INIT_URL") || req.url;
  const destination = getPreferredHomeRedirect({
    originalUrl,
    locale,
    defaultLocale,
    locales,
    lang,
    preferredLocale: getCookie(PREFERRED_LOCALE_COOKIE, { req, res }),
    isCorporate: Boolean(getCookie("corporate-token", { req, res })),
    isDataRequest: Boolean(req.headers["x-nextjs-data"]),
  });
  if (destination) {
    res.setHeader("Cache-Control", "private, no-store");
    return { redirect: { permanent: false, destination } };
  }

  return getSsrCmsPageProps({
    ...props,
    type: getPageTypes().regular,
    slug: "/",
  });
};
